import { Button, DateRangePicker, Icon, Text, HStack, VStack, Stack } from '@genial/components';
import { Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { useNavigation } from '@react-navigation/native';
import { Box, Flex } from 'native-base';
import React from 'react';
import { useRecoilValue } from 'recoil';

import { useDynamicOrdinationContext } from '../../../../../../../../contexts/DynamicOrdination';
import { SignedInNavigationScreenNavigationProp } from '../../../../../../../../routes/types';
import { useSecuritiesTransferActions } from '../../../../../../../../store/customerDetail/SecuritiesTransfer/actions';
import { securitiesTransferFiltersAtom } from '../../../../../../../../store/customerDetail/SecuritiesTransfer/filters';

import { SearchTerm } from './components/SearchTerm';

interface FiltersProps {}

export const Filters: React.FC<FiltersProps> = () => {
  const isDesktop = useBreakpointValue({ base: false, md: true });
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();
  const { updateInvestmentsTransferPeriod, updateInvestmentsTransferSearchTerm } =
    useSecuritiesTransferActions();
  const { appliedFilters } = useRecoilValue(securitiesTransferFiltersAtom);
  const { appliedOrderBy } = useDynamicOrdinationContext();

  const isOrdering = !!appliedOrderBy;

  const handleSearchTerm = (searchTerm: string) => {
    updateInvestmentsTransferSearchTerm(searchTerm);
  };

  const handleSelectDates = (startDate: Date, endDate: Date) => {
    updateInvestmentsTransferPeriod({ startDate, endDate });
  };

  const handleClearDates = () => {
    updateInvestmentsTransferPeriod({ startDate: null, endDate: null });
  };

  return (
    <Stack
      justifyContent="space-between"
      alignItems="center"
      direction={isMobile ? 'column' : 'row'}
      space={{ base: 'stack.xxxs', sm: 0 }}>
      <VStack w="full" maxWidth={{ base: 'full', sm: '30%' }}>
        <SearchTerm loading={false} onSearch={handleSearchTerm} isMobile={isMobile} />
      </VStack>

      <HStack
        pt={isMobile ? 'inline.quarck' : 0}
        width={isMobile ? 'full' : undefined}
        justifyContent={isMobile ? 'space-between' : 'space-around'}
        alignItems="center"
        space="inset.xs">
        {isDesktop ? (
          <>
            <HStack space="inline.quarck" alignItems="center">
              <Icon name="Calendar" size="xxxs" color="neutral.medium" />
              <Text variant="regular" fontSize="md" color="neutral.medium">
                Solicitação por data:
              </Text>
            </HStack>
            <Flex maxW="230px" minW="230px" flex={1} zIndex={10}>
              <DateRangePicker
                onClear={handleClearDates}
                placeholder="Data atual"
                onSelectDates={handleSelectDates}
                calendarPosition="left"
              />
            </Flex>
          </>
        ) : (
          <Button
            onPress={() => navigate('SecuritiesTransferOrderByModal')}
            isDisabled={false}
            alignItems="center"
            justifyContent="center"
            variant="secondary"
            bg="white"
            w="52px">
            <Box>
              <Icon name="Ordering" size="xxs" />
              {isOrdering && (
                <Box
                  w={Typography['fontsize.md']}
                  h={Typography['fontsize.md']}
                  borderRadius="full"
                  background="brand.tertiary.light"
                  position="absolute"
                  top={-12}
                  right={-22}
                />
              )}
            </Box>
          </Button>
        )}
        <Button
          isDisabled={false}
          isLoading={false}
          isLoadingText="Filtrar"
          spinnerPlacement="end"
          _text={{ textTransform: 'none' }}
          onPress={() => navigate('SecuritiesTransferSearchFilter')}
          paddingX="inline.xxxs"
          variant="secondary"
          {...(!appliedFilters.length && { rightIcon: <Icon name="Funnel" size="xxxs" /> })}>
          <HStack alignItems="center" justifyContent="center" space="inline.nano">
            <Text variant="semibold" fontSize="md">
              Filtrar
            </Text>
            {!!appliedFilters.length && (
              <Box
                rounded="full"
                w="20px"
                h="20px"
                alignItems="center"
                justifyContent="center"
                bg={'brand.tertiary.light'}>
                <Text variant="regular" fontSize="xs" color="neutral.white">
                  {appliedFilters.length}
                </Text>
              </Box>
            )}
          </HStack>
        </Button>
      </HStack>
    </Stack>
  );
};
